import Recording from "../models/recording";

import Collection from "backdraft-app/src/collection";

export default class Recordings extends Collection {
  get model() { return Recording; }

  initialize() {
    this.nullRecordingModel = new Recording({});
    this.activeRequest = this.nullRecordingModel;
    this.activeRecording = this.nullRecordingModel;
    this.on('activate', this.handleActivation);
    this.on('fetchRequest', this.setActiveRequest);
    this.on('fetchSuccess', this.handleRequestSuccess);
    this.on('shiftRecordingProgress', this.shiftRecordingProgress);
  }

  handleActivation(model) {
    if (this.activeRecording !== model) {
      this.setActiveRecording(model);
    }
  }

  handleRequestSuccess(model) {
    if (this.activeRequest === model) {
      this.setActiveRecording(model);
    }
  }

  setActiveRequest(model) {
    this.activeRecording.pause();
    this.activeRequest.deactivate();
    this.activeRequest = model;
  }

  setActiveRecording(model) {
    this.deactivate();
    this.activeRecording = model;
    this.trigger('newAudioSrc');
  }

  shiftRecordingProgress(model) {
    if (this.activeRecording === model) {
      this.trigger('newAudioTime');
    } else {
      model.activate();
    }
  }

  deactivate(audioProgress) {
    this.activeRecording.deactivate();
    this.activeRecording = this.nullRecordingModel;
    this.activeRequest = this.nullRecordingModel;
  }
}
